import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useGlobalState } from '../stateProvider/StateProvider';
import Home from '../pages/Home';
import AppRouter from './AppRouter';
import Body from '../layout/Body';
import Content from '../layout/Content';

const ScrollToTop = ({ children, location, hash }) => {
    React.useEffect(() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth', }), [location, hash]);
    return children;
};

const DashRouter = () => {
    // useLocation();
    const { state: {
        active_user
    } } = useGlobalState();

    return (
        <ScrollToTop location={window.location.pathname} hash={window.location.hash}>
            <Body>
                <Routes>
                    <Route index path={''} element={<Home />} />
                    <Route path='*' exact={true} element={<Content><AppRouter /></Content>} />
                </Routes>
            </Body>
        </ScrollToTop>
    );
}

export default DashRouter;
